import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';

export const getAllFilesQuery = registerQuery({
  operationName: 'getAllFilesQuery',
  type: () => [AdornisFile],
  params: [],
  resolve:
    () =>
    async (_gqlFields: BaseQLSelectionSet<AdornisFile>): Promise<AdornisFile[]> => {
      const fileCollection = await getCollection(AdornisFile);
      const allFiles = await fileCollection.find({}).sort({ createdAt: -1 }).toArray();
      return allFiles as AdornisFile[];
    },
});

export const getFileByIDQuery = registerQuery({
  operationName: 'getFileByIDQuery',
  type: () => AdornisFile,
  params: [{ name: 'fileId', type: () => String }],
  resolve:
    (fileId: string) =>
    async (_gqlFields: BaseQLSelectionSet<AdornisFile>): Promise<AdornisFile> => {
      const fileCollection = await getCollection(AdornisFile);
      const file = await fileCollection.findOne({ _id: fileId });
      if (!file) {
        throw new Error('No files found');
      }
      return file as AdornisFile;
    },
});
